export default "__VITE_ASSET__BQQpUiag__"